import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin(() => {
  const {
    public: { sentry },
  } = useRuntimeConfig();

  if (!sentry.dsn) {
    return;
  }

  Sentry.init({
    dsn: sentry.dsn,
    environment: sentry.environment,
    enableLogs: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.piniaIntegration(usePinia()),
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
          hooks: [
            "activate",
            "create",
            "destroy",
            "mount",
            "update",
            "unmount",
          ],
        },
      }),
      Sentry.httpClientIntegration(),
      Sentry.reportingObserverIntegration(),
    ],

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/nuxt/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    // Configure this whole part as you need it!
    tracesSampleRate: 0.2, // Change in prod

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost"],

    replaysSessionSampleRate: 1, // Change in prod
    replaysOnErrorSampleRate: 1, // Change in prod if necessary
  });

  return {
    provide: {
      sentry: Sentry,
    },
  };
});
